import { useSearchParams } from 'react-router-dom';
import { 
    Label,
    TextStyle,
    Button,
    ButtonStyle,
    duploLightTheme } from '@lannister/duplo';
import { FluentProvider } from "@fluentui/react-components";

import { ReactComponent as FailedIcon} from '../../../assets/icons/fail.svg';

import PoweredBy from '../../Checkout/poweredBy';
import LoadingView from '../../loadingView';
import SectionDivider from '../../../Components/Common/sectionDivider';
import usePostPayment from './usePostPayment';
import useResolveTransactionReference from './useResolveTransactionReference';
import InfoRow from './infoRow';
import "./styles.css";

const FailedPatmentView = () => {

    const [searchParams] = useSearchParams();
    const sessionId = searchParams.get('session_id');

    const { merchantInfo, isResolving } = useResolveTransactionReference(sessionId);

    const { isLoading, details, paymentId, redirectToPaymentLink } =
        usePostPayment(merchantInfo.id, merchantInfo.merchant_reference);

    const shouldShowDetails = () => {
        return details?.merchant_reference || merchantInfo.merchant_reference || paymentId;
    }

    return (
        <FluentProvider theme={duploLightTheme}>
            <div className='hero'>
                <div className='header'>
                    <FailedIcon  className='icon'/>
                    <div className='message'>
                        <Label
                            wrap={true}
                            labelText="Payment Failed"
                            textStyle={TextStyle.Heading3Semibold} />
                        <Label
                            wrap={true}
                            labelText="Something went wrong, please try again later."
                            textStyle={TextStyle.Heading5Regular} />
                    </div>
                    <Button
                        buttonStyle={ButtonStyle.Secondary}
                        onClick={() => redirectToPaymentLink(details.merchant_id, details.reference_code)}>
                        Try Again
                    </Button>
                </div>

                <SectionDivider />

                {isLoading || isResolving ? (<LoadingView color='#4055FF' />) :
                    (shouldShowDetails() && (
                        <>
                            <div className='body'>
                                <Label labelText='Invoice Details' textStyle={TextStyle.LargeSemibold} />
                                <InfoRow
                                    label='Invoice ID'
                                    value={details?.merchant_reference ?? merchantInfo.merchant_reference} />
                                <InfoRow label='Transaction ID' value={paymentId} />
                            </div>
                            <SectionDivider />
                        </>
                        )
                    )}

                <div className='fail-footer'>
                    <Label wrap={true} labelText='If you encounter any problems, please contact us:' textStyle={TextStyle.LargeRegular} />
                    <Button buttonStyle={ButtonStyle.Tertiary}>
                        <a style={{ color: "inherit", textDecoration: "none" }} href="mailto:acceptance-support@sahlpay.app">
                            acceptance-support@sahlpay.app
                        </a>
                    </Button>
                </div>

                <PoweredBy />
            </div>
        </FluentProvider>
    );
}

export default FailedPatmentView;
